const actions = [
  {
      title: 'Identify the behaviour you would like to start or stop.',
      text: 'Take a minute to think about the behaviour you are trying to change. Try to be really specific; e.g. “I am going to stop snacking” would be too broad; “I am going to prepare healthy snacks” is much more specific and actionable. Write this  action down in your plan.',
  },
  {
      title: 'Decide when and where you will carry out this action.',
      text: 'Write down the specific scenarios in which you will complete the action in your plan. Include times, days, and places; e.g. “I am going to prepare healthy snacks for the week at home. I am going to do this at 3pm on Sunday afternoons.”',
  },
  {
      title: 'Identify anything you may need to carry out the action.',
      text: 'Have a think about anything extra you may need to carry out the action, and make sure you will have these things available to you at the time. Make a note of this in your plan.',
  },
  {
      title: 'Find somewhere to keep your plan.',
      text: 'Having your plan somewhere visible to you will help to keep it in your mind. Try putting it somewhere like stuck to the fridge, where you\'ll see it frequently.',
  },
];

const tip = 'You want to be able to refer back to your plan - whether it\'s in a journal, on your phone, or stuck to the fridge, choose a place that you know you won\'t forget about it!';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
